import { GlobalState } from 'reducers';
import { getIsFeatureEnabledForUser } from 'selectors/features/getIsFeatureEnabledForUser';
import { Feature } from 'types/types';

export const getIsOnHoldScheduleFilterEnabled = (state: GlobalState) =>
  getIsFeatureEnabledForUser(state, { feature: Feature.OnHoldScheduleFilter });
